/* src/app/components/doc-viewer-new/dialogs/doc-viewer-connections-dialog/doc-viewer-connections-dialog.component.scss */
.connections-list {
  margin-top: 4px;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  padding: 20px;
}
.connection-item {
  background-color: #E4E4E4;
  color: #000;
  border-radius: 5px;
  min-height: 20px;
  width: max-content;
  max-width: 250px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 12px;
}
.connection-item .connection-text {
  font-size: 13px;
  font-weight: 300;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host-context(.dark-theme) .connection-item {
  background-color: #000;
  color: #fff;
}
::ng-deep ::-webkit-scrollbar {
  height: 8px;
  width: 15px;
}
::ng-deep ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: rgb(36, 62, 144);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme ::-webkit-scrollbar {
  height: 12px;
  width: 15px;
}
::ng-deep .dark-theme ::-webkit-scrollbar-thumb {
  -webkit-border-radius: 6px;
  background: #ffc107;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  background-clip: padding-box;
}
::ng-deep .dark-theme ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}
::ng-deep .dark-theme ::-webkit-scrollbar-corner {
  background: #000;
}
/*# sourceMappingURL=doc-viewer-connections-dialog.component.css.map */
